// For Local Development
//const BASE_URL = "http://localhost:5121";

// For Production (Uncomment this and comment out the Local URL above when deploying)
 const BASE_URL = "https://apiv2.chakran.in";

const API_BASE_URL = `${BASE_URL}/api`;
const HUB_URL = `${BASE_URL}/notificationHub`;

export { BASE_URL, API_BASE_URL, HUB_URL };
export default API_BASE_URL;
